module.exports = __webpack_public_path__ + "img/9788983926609.097b129b.jpg";